import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import type { PurchaseMethod } from '@patrianna-payments/shared-store/payments/types/openApiModels/PurchaseMethod'

import CardName from 'pageContainers/TransactionsPage/components/PaymentsTab/components/CardName'
import ProviderName from 'pageContainers/TransactionsPage/components/ProviderName'
import content from 'prismic-translates/transactions-history-page.json'
import { maskingString } from 'utils/maskingString'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

const MASK_LENGTH = 8

const getPaymentData = ({
  cardNumberMask,
  accountNumberMask,
  email,
}: Pick<PurchaseMethod, 'cardNumberMask' | 'accountNumberMask' | 'email'>) => {
  if (cardNumberMask) {
    return <span>{maskingString({ str: cardNumberMask.padStart(MASK_LENGTH, '0') })}</span>
  }

  if (accountNumberMask) {
    return <span>{maskingString({ str: accountNumberMask, separator: '' })}</span>
  }

  if (email) {
    return <span className={classes.email}>{email}</span>
  }

  return ''
}

export default function TransactionName({
  cardNumberMask = null,
  accountNumberMask = null,
  cardBrand = null,
  email = null,
  integrationType,
}: PurchaseMethod) {
  return (
    <>
      {t('instrument')}: {cardBrand ? <CardName cardBrand={cardBrand} /> : <ProviderName provider={integrationType} />}{' '}
      {getPaymentData({ cardNumberMask, accountNumberMask, email })}
    </>
  )
}
